import { useEffect, useState } from "react";
import { connect } from "react-redux";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTableForTop10";

import Cookies from "universal-cookie";

import { format, addMinutes } from "date-fns";

import { getVendorApplication } from "../../store";
import { useNavigate } from "react-router-dom";

const cookies = new Cookies();

const VendorApplication = ({
  getVendorApplication,
  getVendorApplicationReducer,
}) => {
  const navigate = useNavigate();
  let loginDetails = cookies.get("loginDetailsForWMS");
  let role = loginDetails.data.role;

  let jwtToken = loginDetails?.jwt;

  const [top10Data, setTop10Data] = useState([]);

  useEffect(() => {
    getVendorApplication(jwtToken);
  }, []);

  useEffect(() => {
    let data = getVendorApplicationReducer.top10.data
      ? getVendorApplicationReducer.top10.data
      : [];
    console.log("data", data);

    setTop10Data(data);
    // alert(JSON.stringify(data));
  }, [getVendorApplicationReducer]);

  // console.log(top10Data);

  const [state, setState] = useState({
    columns: [
      { Header: "Supplier Id", accessor: "vendorId" },
      { Header: "email", accessor: "email" },
      { Header: "status", accessor: "status" },
      { Header: "Submission Date", accessor: "createdDate" },
    ],
    rows: [],
  });
  const { columns, rows } = state;
  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getVendorApplicationReducer.top10.data
      ? getVendorApplicationReducer.top10.data
      : [];
    // setLoading(getVendorApplicationReducer.loading);
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.submissionDate);
      const finishedGoodsObject = {
        vendorId: finishedGoods.vendorId,
        email: finishedGoods.email,
        location: finishedGoods.locationCode,
        documentNumber: finishedGoods.documentNumber,
        qty: `${finishedGoods.qty} `,
        uom: `${finishedGoods.uom} `,
        sku: finishedGoods.sku,
        ageing: finishedGoods.ageing,
        suid: finishedGoods.suid,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa"
        ),
        cd: finishedGoods.cd,
        status: (
          <button
            className={
              (finishedGoods.status === "Approved" && `status-success`) ||
              (finishedGoods.status === "New" && `status-info`) ||
              (finishedGoods.status === "Pending" && `status-warning`) ||
              (finishedGoods.status === "Rejected" && `status-error`)
            }
            style={{ width: "5.5rem" }}
            onClick={() => {
              finishedGoods.status === "Approved" &&
                navigate("/registered-suppliers");
              finishedGoods.status === "New" && navigate("/status");
              finishedGoods.status === "Pending" && navigate("/status");
              finishedGoods.status === "Rejected" &&
                navigate("/rejected-suppliers");
            }}
          >
            {(finishedGoods.status === "Approved" && `Approved`) ||
              (finishedGoods.status === "New" && `New`) ||
              (finishedGoods.status === "Pending" && `Pending`) ||
              (finishedGoods.status === "Rejected" && `Rejected`)}
          </button>
        ),
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    setState({ ...state, rows: tempFinishedGoods });
  }, [getVendorApplicationReducer]);

  return (
    <Card
      style={{
        height: "fit-content",
        overflow: "auto",
        marginBottom: "-1.5rem",
      }}
    >
      <MDBox mt={0} style={{ height: "fit-content", overflow: "auto" }}>
        <DataTable
          table={{ columns, rows }}
          showTotalEntries={false}
          isSorted={false}
          noEndBorder
          entriesPerPage={false}
        />
      </MDBox>
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    getVendorApplicationReducer: state.getVendorApplicationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getVendorApplication: (jwtToken) =>
      dispatch(getVendorApplication(jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VendorApplication);
